export const SENDING_REQUEST = 'RECOVERYPRICELIST_SENDING_REQUEST';
export const GETALL_SUCCESS = 'RECOVERYPRICELIST_GETALL_SUCCESS';
export const GETALL_FAILURE = 'RECOVERYPRICELIST_GETALL_FAILURE';